import { render, staticRenderFns } from "./colDrop.vue?vue&type=template&id=203ec056&scoped=true"
import script from "./colDrop.vue?vue&type=script&lang=js"
export * from "./colDrop.vue?vue&type=script&lang=js"
import style0 from "./colDrop.vue?vue&type=style&index=0&id=203ec056&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203ec056",
  null
  
)

export default component.exports